
import React from 'react'
import { ConversationHistory } from '../../components/ConversationHistory'
import { useChatContext } from '../../../../contexts/ChatContext'
import { useChatConversations } from '../../hooks/useChatConversations'
import { useUser } from '../../../../contexts/UserContext'

interface HistoryViewProps {
    onClose: () => void
}

export const HistoryView: React.FC<HistoryViewProps> = ({
    onClose
}) => {
    // Consume Context
    // Use Context for stable Identifiers only
    const { currentAgentId } = useChatContext()
    const { user } = useUser()
    const userId = user?.id || null

    // Atomic Hooks
    const { conversations, currentConversationId, switchConversation, deleteConversation } = useChatConversations(userId, currentAgentId)

    return (
        <ConversationHistory
            conversations={conversations.map(conv => ({
                id: conv.id,
                title: conv.title || 'Nova Conversa',
                timestamp: new Date(conv.created_at).getTime()
            }))}
            currentConversationId={currentConversationId}
            onConversationClick={(conv) => {
                switchConversation(conv.id)
                onClose()
            }}
            onConversationDelete={(id, e) => {
                e.stopPropagation()
                deleteConversation(id)
            }}
            onClose={onClose}
        />
    )
}
